import { Alert, Button, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { UserAccessStatePanel } from './UserAccessStatePanel';

type UserAccessErrorStateProps = {
  header?: ReactNode;
  message?: ReactNode;
  onRetry?: () => void;
};

export function UserAccessErrorState({ header, message, onRetry }: UserAccessErrorStateProps) {
  const { t } = useTranslation();

  return (
    <UserAccessStatePanel header={header}>
      <Stack p={2} spacing={2} alignItems="center" justifyContent="center" flex={1}>
        <Alert severity="error" sx={{ width: '100%' }}>
          {message ?? t('error.api.title')}
        </Alert>
        {onRetry && (
          <Button variant="contained" onClick={onRetry}>
            {t('error.dialog.tryAgain')}
          </Button>
        )}
      </Stack>
    </UserAccessStatePanel>
  );
}
